import Vue, { reactive } from "vue";
import { defineStore } from "pinia";
export const useWorkflowStateStore = defineStore("workflowStateStore", {
    state: () => ({
        inputTerminals: {},
        outputTerminals: {},
        draggingPosition: null,
        draggingTerminal: null,
        activeNodeId: null,
        scale: 1,
        stepPosition: {},
        stepLoadingState: {},
    }),
    getters: {
        getInputTerminalPosition(state) {
            return (stepId, inputName) => {
                var _a;
                return (_a = state.inputTerminals[stepId]) === null || _a === void 0 ? void 0 : _a[inputName];
            };
        },
        getOutputTerminalPosition(state) {
            return (stepId, outputName) => {
                var _a;
                return (_a = state.outputTerminals[stepId]) === null || _a === void 0 ? void 0 : _a[outputName];
            };
        },
        getStepLoadingState(state) {
            return (stepId) => state.stepLoadingState[stepId];
        },
    },
    actions: {
        setInputTerminalPosition(stepId, inputName, position) {
            if (!this.inputTerminals[stepId]) {
                Vue.set(this.inputTerminals, stepId, {});
            }
            Vue.set(this.inputTerminals[stepId], inputName, position);
        },
        setOutputTerminalPosition(stepId, outputName, position) {
            if (!this.outputTerminals[stepId]) {
                Vue.set(this.outputTerminals, stepId, reactive({}));
            }
            Vue.set(this.outputTerminals[stepId], outputName, position);
        },
        deleteInputTerminalPosition(stepId, inputName) {
            var _a;
            (_a = this.inputTerminals[stepId]) === null || _a === void 0 ? true : delete _a[inputName];
        },
        deleteOutputTerminalPosition(stepId, outputName) {
            var _a;
            (_a = this.outputTerminals[stepId]) === null || _a === void 0 ? true : delete _a[outputName];
        },
        setActiveNode(nodeId) {
            this.activeNodeId = nodeId;
        },
        setScale(scale) {
            this.scale = scale;
        },
        setStepPosition(stepId, position) {
            Vue.set(this.stepPosition, stepId, position);
        },
        deleteStepPosition(stepId) {
            delete this.stepPosition[stepId];
        },
        setLoadingState(stepId, loading, error) {
            Vue.set(this.stepLoadingState, stepId, { loading, error });
        },
    },
});
